export default "__VITE_ASSET__a949adde__"